import Web3Modal from 'web3modal';
/*
import WalletConnectProvider from '@walletconnect/web3-provider';

import Fortmatic from 'fortmatic';
import Torus from '@toruslabs/torus-embed';
import UniLogin from '@unilogin/provider';
import Authereum from 'authereum';
import BurnerConnectProvider from '@burner-wallet/burner-connect-provider';
*/
//import BurnerConnectProvider from '@burner-wallet/burner-connect-provider';

// Enter a valid infura key here to avoid being rate limited
// You can get a key for free at https://infura.io/register
//const INFURA_ID = 'INVALID_INFURA_KEY';

// Web3Modal also supports many other wallets.
// You can see other options at https://github.com/Web3Modal/web3modal
export const web3Modal = new Web3Modal({
	network: 'mainnet',
	cacheProvider: true,
	providerOptions: {
		/*
		burnerconnect: {
			package: BurnerConnectProvider, // required
			options: {
				defaultNetwork: '3'
			}
		}
		
		walletconnect: {
			package: WalletConnectProvider,
			options: {
				infuraId: process.env.INFURA_ID
			}
		}*/
		/*,
		fortmatic: {
			package: Fortmatic, // required
			options: {
				key: 'FORTMATIC_KEY' // required
			}
		},
		torus: {
			package: Torus, // required
			options: {
				networkParams: {
					host: 'https://localhost:8545', // optional
					chainId: 1337, // optional
					networkId: 1337 // optional
				},
				config: {
					buildEnv: 'development' // optional
				}
			}
		},
		authereum: {
			package: Authereum // required
		},
		unilogin: {
			package: UniLogin // required
		},
		burnerconnect: {
			package: BurnerConnectProvider, // required
			options: {
				defaultNetwork: '100'
			}
		} */
		/*,
		portis: {
			package: Portis, // required
			options: {
				id: 'PORTIS_ID' // required
			}
		}*/
	},
	theme: 'dark'
});

export const logoutOfWeb3Modal = async function() {
	await web3Modal.clearCachedProvider();
	window.location.reload();
};
